import { useEffect, useState } from 'react';

const portraitQuery = () =>
  typeof window !== 'undefined' && window.matchMedia ? window.matchMedia('(orientation: portrait)') : null;

/**
 * Plays the portrait recording on phones and upright tablets, the landscape one on
 * laptops and sideways tablets, switching if the device is turned.
 */
export function HelpVideo({ name, label }: { name: 'how-to-play' | 'techniques'; label: string }) {
  const [portrait, setPortrait] = useState(() => portraitQuery()?.matches ?? true);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const q = portraitQuery();
    if (!q) return;
    const on = (e: MediaQueryListEvent) => setPortrait(e.matches);
    q.addEventListener('change', on);
    return () => q.removeEventListener('change', on);
  }, []);

  const base = `${import.meta.env.BASE_URL}videos/${name}-${portrait ? 'portrait' : 'landscape'}`;
  if (failed) return <p className="video-missing">The video couldn&apos;t be loaded. The text explains everything it shows.</p>;
  return (
    <video
      key={base}
      className={`help-video ${portrait ? 'is-portrait' : 'is-landscape'}`}
      poster={`${base}.jpg`}
      controls
      playsInline
      muted
      preload="metadata"
      aria-label={label}
    >
      <source src={`${base}.mp4`} type="video/mp4" />
      {/* Fallback for browsers without H.264; if neither plays, show the note instead. */}
      <source src={`${base}.webm`} type="video/webm" onError={() => setFailed(true)} />
    </video>
  );
}
